import { z } from "zod";
export const DTOForgeFeatureRoom = z.object({
    id: z.string(),
});
export const DTOForgeFeatureRoomResponse = z.object({
    room: DTOForgeFeatureRoom,
});
